import * as urls from "../../../api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "components/AppSimpleBar";
import Loader from "components/Loader";
import MasterPage1Column from "pages/MasterPage1Column";


const EachCommand: React.FC<
  { category: string, buttonText: string, dataCount: number, lastSync: any, btnClass?: string | null, onClick(category: string): void }
> = ({ category, buttonText, dataCount, lastSync, btnClass, onClick }) => {
  const infoText = () => {
    switch (category) {
      case "sync_Customer": return "Sync ข้อมูล Customer เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "sync_Supplier": return "Sync ข้อมูล Supplier เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "sync_Employee": return "Sync ข้อมูล Employee เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "sync_Province1": return "Sync ข้อมูล Province จากระบบ ERP";
      case "sync_Users": return "Sync ข้อมูล User (Erp User) เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "sync_WebUser": return "Sync ข้อมูล Web User (d-connect) เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "sync_EndUser": return "Sync ข้อมูล End User (2s-online) เฉพาะที่มีการเปลี่ยนแปลง จากระบบ ERP";
      case "Re-Sync All Above": return "Sync ข้อมูลด้านบนใหม่ทั้งหมด";
      case "WpTag-CUS": return "สร้างข้อมูล Workplace Tag-Customer จาก Customer ที่ Sync มา";
      case "WpTag-EMP": return "สร้างข้อมูล Workplace Tag-Employee จาก Employee ที่ Sync มา";
      case "WpTag-SUP": return "สร้างข้อมูล Workplace Tag-Supplier จาก Supplier ที่ Sync มา";
      case "sp_AddErpUserEmployeeToChatUserIfNotYetExists": return "สร้างผู้ใช้งานใน Chat.2S/Workplace หากยังไม่มี โดยใช้ข้อมูลจาก Erp User";
      case "sp_AddSaleCsToChatRoom": return "เพิ่ม Sale/CS ลงห้องแชท (หากยังไม่อยู่ในห้อง)";
    }
    return category;
  }



  return (
    <div className="row align-items-center">
      <div className="col-3">
        <button className={"btn btn-outline-" + (btnClass != null ? btnClass : "primary") + " w-100"} onClick={() => onClick(category)}>
          {buttonText}
        </button>
      </div>
      <div className="col-9">
        <div className="text-danger">
          {lastSync && (<>Last sync : {lastSync}</>)}
          {dataCount > 0 && (
            <span className="ms-2 text-info">[ทั้งหมดมี {Utils.FormatNumber(dataCount, 0)} รายการ]</span>
          )}
        </div>
        <div className="text-secondary" style={{ marginTop: "-4px" }}>{infoText()}</div>
      </div>
    </div>
  )
}

const SyncComponent: React.FC<{}> = ({ }) => {
  const [isSearch2, setIsSearch2] = useState<boolean>(false);
  const [syncStatus2, setSyncStatus2] = useState<any[]>([]);
  const onSearch2 = () => {
    try {
      const api = new APIClient();
      setIsSearch2(true);
      api.fnPostForm(urls.SYNC_ERP_DATA_LOAD_STATUS, {})
        .then(rs => {
          // console.log('setSyncStatus2:', rs);
          setSyncStatus2(rs);
          setIsSearch2(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setIsSearch2(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSearch2(false);
    }
  }

  useEffect(() => {
    onSearch2();
  }, []);

  const onClick = async (category: string) => {
    try {
      setIsSearch2(true);
      const api = new APIClient();
      api.fnPostForm(urls.SYNC_ERP_DATA_PERFORM, { category: category })
        .then(rs => {
          alert('Done');
          setSyncStatus2(rs);
          setIsSearch2(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setIsSearch2(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSearch2(false);
    }
  }


  return (
    <div>
      {isSearch2 && (<Loader />)}
      <AppSimpleBar style={{ maxHeight: "calc(100vh - 100px)" }}>
        {syncStatus2.map((x: any) => (
          <>
            <EachCommand key={x.category} category={x.category} buttonText={x.caption} lastSync={x.lastRun} dataCount={x.dataCount} onClick={onClick} />
            {/* <hr className="my-1" style={{ height: "5px", border: "none", backgroundColor: "black" }} /> */}
            <div key={x.category+'1'} className="my-1" style={{ height: "5px", backgroundColor: "var(--bs-body-bg)" }}></div>

          </>
        ))}
      </AppSimpleBar>
    </div>
  );
}

const DataSettingSyncErpData = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  return (
    <MasterPage1Column
      titleText="Sync ข้อมูลจากระบบ ERP มายังระบบ Chat/WorkPlace"
      titleIcon="fas fa-sync-alt"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<SyncComponent />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingSyncErpData;